import {useState} from 'react'
import {MessageType} from '../pages/UserPages/reports-analytics/Types'

export function useReportFilterAndPage() {
  const [campType, setCampType] = useState<MessageType>(MessageType.SMS)
  const [page, setPage] = useState(1)
  const [mmsPage, setMmsPage] = useState(1)

  // configure date range
  const today = new Date() // Current date
  const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

  const [dateRange, setDateRange] = useState<any>([startOfMonth, new Date()])
  const [startDate, endDate] = dateRange

  const [dateRangeMms, setDateRangeMms] = useState<any>([startOfMonth, new Date()])
  const [startDateMms, endDateMms] = dateRangeMms

  const [showId, setShowID] = useState('')
  const [showMmsId, setShowMmsID] = useState('')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('')
  const [limit, setLimit] = useState(10)

  // mms
  const [searchMms, setSearchMms] = useState('')
  const [statusMms, setStatusMms] = useState('')
  const [limitMms, setLimitMms] = useState(10)

  return {
    campType,
    setCampType,

    page,
    setPage,
    mmsPage,
    setMmsPage,

    dateRange,
    setDateRange,
    startDate,
    endDate,

    dateRangeMms,
    setDateRangeMms,
    startDateMms,
    endDateMms,

    showId,
    setShowID,

    showMmsId,
    setShowMmsID,

    search,
    setSearch,
    status,
    setStatus,
    limit,
    setLimit,

    searchMms,
    setSearchMms,
    statusMms,
    setStatusMms,
    limitMms,
    setLimitMms,
  }
}
